<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div>
    <section id="join" class="py-12 bg-white">
      <div class="container mx-auto px-4">
        <div class="text-center mb-8">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">联系我们</h2>
          <p class="text-gray-600">填写表单与我们取得联系</p>
        </div>
        
        <div class="max-w-4xl mx-auto">
          <div class="rounded-xl shadow-lg overflow-hidden border border-gray-200">
            <iframe
              :src="formUrl"
              class="w-full"
              :height="iframeHeight"
              frameborder="0"
              allowfullscreen
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            ></iframe>
          </div>
          
          <div class="mt-8 text-center text-sm text-gray-500">
            <p>如果表单无法正常显示，请<a :href="formUrl" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">点击此处</a>在新窗口打开</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";

const formUrl = ref('https://dcnf604l23wl.feishu.cn/share/base/form/shrcnCOV6E7LcmdnTiecGKtNzFf')
const iframeHeight = ref(600)

const updateIframeHeight = () => {
  iframeHeight.value = window.innerHeight > 800 ? 800 : window.innerHeight - 200
}

onMounted(() => {
  updateIframeHeight()
  window.addEventListener('resize', updateIframeHeight)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateIframeHeight)
})
</script>

<style scoped>
</style>
